export default __webpack_public_path__ + "static/climate-environmental-justice-accomplishment-3-6d9b0cb853e53e186fbba69e8bf441bc.webp";